import GameNavigation from "../components/navigator"
import { Privacy } from "../components/privacy"
export const PrivacyScreen = () => {
    return (
        <>
            <GameNavigation />
            <Privacy />
        </>
    )
}